import React, { useCallback } from 'react'
import { FormDamage } from 'pages/damage_reports/DamageReportForm/types'
import { VehiclePicker } from './VehiclePicker'
import classes from './DamageIllustrations.module.scss'

interface DamageIllustrationsProps {
  prefix: string
  values: FormDamage
  setFieldValue: (field: any, value: any) => void
}

export const DamageIllustrations: React.FunctionComponent<DamageIllustrationsProps> = ({
  prefix,
  values,
  setFieldValue,
}) => {
  const setDamage = useCallback(
    (field, value) => setFieldValue(`${prefix}.${field}`, value),
    [setFieldValue, prefix]
  )

  return (
    <div className={classes.illustrations}>
      <VehiclePicker setDamage={setDamage} damages={values} />
      <VehiclePicker setDamage={setDamage} damages={values} mirror />
    </div>
  )
}
